import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Header';
import axios from 'axios';
import HeroSection from '../../components/CommercialRealEstate/HeroSection';
import Content from '../../components/CommercialRealEstate/Content';
import Footer from '../../components/Footer';

function CommercialRealEstate() {
  let [data, setData] = useState([]);
  let [filterData, setFilterData] = useState([]);
  const [searchResult, setSearchResult] = useState(null);

  useEffect(() => {
    async function getData() {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/properties/approved-commercial`);
        setData(res.data);
        setFilterData(res.data);
      } catch (err) {
        console.error('Error fetching commercial properties:', err);
        setData([]);
        setFilterData([]);
      }
    }

    getData();
  }, []);

  function handleFilter(searchResult) {
    let filtered = [...data];

    if (searchResult.city && searchResult.city !== 'Dubai') {
      filtered = filtered.filter((property) =>
        property.location.includes(searchResult.city)
      );
    }

    if (searchResult.propertyType !== 'Any') {
      filtered = filtered.filter(
        (property) => property.propertyType === searchResult.propertyType
      );
    }

    if (searchResult.price !== 'Any') {
      filtered = filtered.filter(
        (property) => parseInt(property.price) > parseInt(searchResult.price)
      );
    }

    if (searchResult.complete !== 'Any') {
      filtered = filtered.filter(
        (property) => property.propertyStatus === searchResult.complete
      );
    }

    setFilterData(filtered);
  }

  return (
    <div>
      <Navbar />
      <HeroSection
        searchResult={searchResult}
        setSearchResult={setSearchResult}
        handleFilter={handleFilter}
      />
      <Content data={filterData} />
      <Footer />
    </div>
  );
}

export default CommercialRealEstate;
